import React from 'react';
import { Tooltip } from 'react-tippy-without-bugs';
import Info from './assets/question.svg';

const Tip = ({ message }) => (
  <Tooltip
    title={message}
    animation="fade"
    distance={10}
    position="top"
    arrow
    style={{ marginLeft: '8px' }}
  >
    <img src={Info} alt="" style={{ verticalAlign: 'middle' }} />
  </Tooltip>
);

export default Tip;
